import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'arraySortByKey',
  standalone: true
})
export class ArraySortByKeyPipe implements PipeTransform {

  public transform<T>(arr: T[], key: keyof T, sortingType: 'asc' | 'desc' = 'asc'): T[] {
    return arr.sortByKey(key, sortingType);
  }
}
